import { API_BASE_URL } from '../../utils/constants';
import HttpClient from '../../utils/http-client';

class Cortex {
  getThreadList = (workspaceId: number) => HttpClient.get(`${API_BASE_URL}/v1/cortex/list/threads/${workspaceId}`);

  getThreadDetails = (threadId: string) => HttpClient.get(`${API_BASE_URL}/v1/cortex/thread/${threadId}`);

  deleteThread = (threadId: string) => HttpClient.delete(`${API_BASE_URL}/v1/cortex/thread/${threadId}`);

  postQuery = (workspaceId: number, threadId: string, data: {query: string, filters: {[key:string]: any}}) =>
    HttpClient.post(`${API_BASE_URL}/v2/cortex/query/${workspaceId}/thread/${threadId}`, data)
}

const CortexService = new Cortex();

export default CortexService;
